import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import { ResponsiveEmbed } from "react-bootstrap";
import LevelEmployeeServices from "./LevelEmployee.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetLevelEmployee = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_LEVEL_EMPLOYEE,
      payload: true,
    });
    dispatch({
      type: actions.GET_LEVEL_EMPLOYEE,
      payload: {
        levelEmployees: [],
        levelEmployeesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.LEVEL_EMPLOYEE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_LEVEL_EMPLOYEE,
      payload: false,
    });
  }
};

export const getLevelEmployee = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_LEVEL_EMPLOYEE,
      payload: true,
    });
    const resp = await LevelEmployeeServices.getLevelEmployee(filters);
    dispatch({
      type: actions.GET_LEVEL_EMPLOYEE,
      payload: {
        levelEmployees: resp.data.data || [],
        levelEmployeesLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.LEVEL_EMPLOYEE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.LEVEL_EMPLOYEE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_LEVEL_EMPLOYEE,
      payload: false,
    });
  }
};

export const getLevelEmployeeById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_LEVEL_EMPLOYEE_BY_ID,
      payload: true,
    });
    const resp = await LevelEmployeeServices.getLevelEmployeeById(id);
    dispatch({
      type: actions.GET_LEVEL_EMPLOYEE_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.LEVEL_EMPLOYEE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.LEVEL_EMPLOYEE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_LEVEL_EMPLOYEE_BY_ID,
      payload: false,
    });
  }
};

export const saveLevelEmployee = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_LEVEL_EMPLOYEE,
      payload: true,
    });
    await LevelEmployeeServices.saveLevelEmployee(data);
   
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_LEVEL_EMPLOYEE,
      payload: false,
    });
  }
};

export const editLevelEmployee = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_LEVEL_EMPLOYEE,
      payload: true,
    });
    await LevelEmployeeServices.editLevelEmployee(id, data);
    
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_LEVEL_EMPLOYEE,
      payload: false,
    });
  }
};

export const deleteLevelEmployee = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_LEVEL_EMPLOYEE,
      payload: true,
    });
    await LevelEmployeeServices.deleteLevelEmployee(id);
    const { levelEmployees, levelEmployeesLength } = getState().levelEmployee;
    levelEmployees.splice(index, 1);
    dispatch({
      type: actions.GET_LEVEL_EMPLOYEE,
      payload: {
        levelEmployees: levelEmployees,
        levelEmployeesLength: levelEmployeesLength - 1,
      },
    });
    dispatch({
      type: actions.LEVEL_EMPLOYEE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_LEVEL_EMPLOYEE,
      payload: false,
    });
  }
};
